import { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import {
  FieldValues,
  FormProvider,
  SubmitErrorHandler,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';

export type FormProps<
  TFieldValues extends FieldValues = FieldValues,
  TTransformedValues extends FieldValues = TFieldValues,
> = {
  methods: UseFormReturn<TFieldValues, any, TTransformedValues>;
  onSubmit: SubmitHandler<TTransformedValues>;
  onError?: SubmitErrorHandler<TFieldValues>;
} & Omit<ComponentPropsWithoutRef<'form'>, 'onSubmit' | 'onError'>;

const Form = <
  TFieldValues extends FieldValues = FieldValues,
  TTransformedValues extends FieldValues = TFieldValues,
>(
  props: PropsWithChildren<FormProps<TFieldValues, TTransformedValues>>
) => {
  const { children, onSubmit, onError, methods, ...rest } = props;

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit, onError)} {...rest}>
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
